import { render, staticRenderFns } from "./ModalButton.vue?vue&type=template&id=c9e49b0a&scoped=true&"
import script from "./ModalButton.vue?vue&type=script&lang=ts&"
export * from "./ModalButton.vue?vue&type=script&lang=ts&"
import style0 from "./ModalButton.vue?vue&type=style&index=0&id=c9e49b0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9e49b0a",
  null
  
)

export default component.exports